import { savePartialLeadToFirebase, saveCompleteLeadToFirebase } from "./firebaseService";

// O LeadBroker saiu do fluxo do formulário: o lead completo vai direto para o
// ERP (crm-biancode), que é onde o comercial trabalha. O que sobra aqui é o
// Firebase, que guarda o histórico e é o único lugar onde o parcial de quem
// abandonou continua registrado.

const registrar = async (label, promessa) => {
  const resultado = await Promise.allSettled([promessa]);
  const [r] = resultado;
  const ok = r.status === "fulfilled" && r.value?.success !== false;
  console[ok ? "log" : "warn"](
    `[LeadService] Firebase ${label}: ${ok ? "SUCCESS" : "FAILED"}`,
    ok ? "" : r.status === "rejected" ? r.reason : r.value
  );
};

export const submitPartialLead = async (leadData) => {
  await registrar("partial save", savePartialLeadToFirebase(leadData));
};

export const submitCompleteLead = async (leadData) => {
  await registrar("complete save", saveCompleteLeadToFirebase(leadData));
};
